/**
 * All amounts in the app are in PKR (Pakistani Rupees).
 * Use these helpers for consistent, readable display (comma-separated thousands).
 */

const defaultOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  locale: 'en-PK'
};

/**
 * Format a number as PKR with "Rs." prefix and comma-separated thousands.
 * e.g. formatPKR(100000) → "Rs. 100,000.00"
 */
export function formatPKR(num) {
  const n = parseFloat(num);
  if (Number.isNaN(n)) return 'Rs. 0.00';
  return `Rs. ${n.toLocaleString(defaultOptions.locale, defaultOptions)}`;
}

/**
 * Format a number as PKR amount without symbol (e.g. for inputs or labels).
 * e.g. formatPKRNumber(100000) → "100,000.00"
 */
export function formatPKRNumber(num) {
  const n = parseFloat(num);
  if (Number.isNaN(n)) return '0.00';
  return n.toLocaleString(defaultOptions.locale, defaultOptions);
}

/** Currency code for labels (e.g. "Amount (PKR)") */
export const CURRENCY_CODE = 'PKR';
